import React, { Component, useState } from 'react'
import client from "./../../utils/apolloClient";
import getData from "./../../data-services/api";
import { getUser } from "./../../data-services/queries";
import gql from "graphql-tag";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { Table, TableRow, TableCell, TableHead, TableBody } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import IconButton from "@material-ui/core/IconButton";
import './Fevicryl.css';
import Loader from "./../../components/CustomLoader";
import _ from "lodash";
// import { useLocation } from 'react-router-dom';
import { FaRegBookmark } from "react-icons/fa6";

export default class FevicrylDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            productData:{
                craft_category__c:"Best out of waste ",
                id : "25",
                in_house_products_used__c :"Fevicryl Acrylic Colours - White 27, Sky Blue 63, Teal Blue 68, Fevicryl Acrylic Colours Pearl - Metallic Bronze 355, Fevicryl Mouldit, Fevicryl Fabric Glue, Fine Art Brushes ",
                level_of_difficulty__c : "Advanced ",
                link_in_pil_tantra__c: null,
                name:"ALARM CLOCK PHOTO FRAME",
                non_pil_product_price__c:"To be included later",
                out_sourced_products_use__c:"Plastic Container, Paper Cutter, Corrugated Sheet / Card Board Paper, Wooden Stick, OHP Sheet, CD Marker, Scissors, Clay Carving Tools, Colour Palette, Water Container, Colour Palette ",
                pil_product_price__c:"To be included later",
                seasonality__c:"General﻿",
                thumbnail_url__c:"https://i.ibb.co/YyfjDdG/ALARM-CLOCK-PHOTO-FRAME.jpg",
                time_period__c:"April - June",
                total_cost_of_making_the_article__c:"To be included later",
             }
        };
    }
    
    async componentDidMount() {
        this.setState({
            loading:false
        });
    }

    render() {
        const {loading, productData } = this.state;
        const { classes, history} = this.props;
        const data = history.location.productData ? history.location.productData : productData;

        //console.log("data", data, history.location.productData )
        return (
            <>
                <AppBar position="static">
                    <Toolbar>
                        <Grid item xs={2} sm={2} md={2}>
                            <IconButton
                                color="inherit"
                                aria-label="Menu"
                                onClick={() => {
                                    history.goBack();
                                }}
                            >
                                <ArrowBackIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={8} sm={8} md={8}>
                            <Typography
                                variant="title"
                                color="inherit"
                                className='text-center'
                            >
                                Fevicryl Content Categorization
                            </Typography>
                        </Grid>
                    </Toolbar>
                </AppBar>
                {loading ? (
                    <Grid container alignItems="center" justify="center">
                        <Loader type="Audio" color="#00BFFF" height="50" width="50" />
                    </Grid>
                ) : (
                    <>
                            {/* {data && data.map((item) => {
                        return( */}
                            <>
                                <div className='fevicyrlDetails__outerBox row m-0'>
                                    <div className='col-lg-6 col-md-6 fevicyrlDetails__innerBox'>
                                        <div className='d-flex justify-content-between'>
                                            <div className='fevicyrlDetails__name'>
                                                {data.name}
                                            </div>
                                            <div className='fevicyrlDetails__bookmark' ><FaRegBookmark /></div>
                                        </div>
                                            <img src={data.thumbnail_url__c} />
                                            <p className='fevicyrlDetails__info'>
                                                {data.out_sourced_products_use__c}
                                            </p>
                                        <div className='fevicyrlDetails__InfoBoxs'>
                                            <div className='fevicyrlDetails__labelBox'>{data.seasonality__c}</div>
                                            <div className='fevicyrlDetails__labelBox'>{data.craft_category__c}</div>
                                            <div className='fevicyrlDetails__labelBox'>{data.time_period__c}</div>
                                            <div className='fevicyrlDetails__labelBox'>{data.level_of_difficulty__c}</div>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 fevicyrlDetails__innerBox2'>
                                        <div className='fevicyrlDetails__amountBox'>
                                            <div className='row fevicyrlDetails__amountRow'>
                                                <div className='col-8 fevicyrlDetails__amountTitle'>PIL Product Price</div>
                                                <div className='col-4 fevicyrlDetails__amount'>{data.non_pil_product_price__c}</div>
                                            </div>
                                            <div className='row fevicyrlDetails__amountRow'>
                                                <div className='col-8 fevicyrlDetails__amountTitle'>Non-PIL Product Price</div>
                                                <div className='col-4 fevicyrlDetails__amount'>{data.pil_product_price__c}</div>
                                            </div>
                                            <div className='row m-0 fevicyrlDetails__amountTitle2'>
                                                <div className='col-8 fevicyrlDetails__amountTitle'>Total Cost of Making</div>
                                                <div className='col-4 fevicyrlDetails__amount'>{data.total_cost_of_making_the_article__c}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        {/* )
                    })} */}
                    </>
                )}
            </>
        )
    }
}
